{
  "title": "Assistant",
  "newChat": "New chat",
  "placeholder": "Describe the student to add...",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "undo": "Undo",
  "resultLine": "Created {{created}}, updated {{updated}}",
  "undoneLine": "Undone",
  "sentinelConfirmLabel": "Confirm",
  "sentinelUndoLabel": "Undo",
  "history": "Chat history",
  "historyEmpty": "No conversations yet",
  "historyDeleteTitle": "Delete this conversation?",
  "historyDeleteCancel": "Cancel",
  "historyDeleteBody": "This action cannot be undone. The entire conversation will be permanently deleted.",
  "historyDeleteConfirm": "Delete",
  "credits": {
    "remaining": "{{remaining}}/{{limit}} AI credits left this month",
    "unlimited": "Unlimited AI",
    "exhausted": "Out of AI credits this month — upgrade to keep going"
  }
}
